module.exports = __webpack_public_path__ + "static/media/sv2.cbbdb8aa.jpg";